var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('v-overlay',{attrs:{"value":true,"opacity":"0.7","color":"black"}},[_c('div',[_vm._v(" sdasda ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }